import { Roles } from '@frontend-workspace/react-shared-lib';
import React, { useState, useEffect, useContext } from 'react';
import { ITokenType } from './_models/token-type';
import { ro } from 'date-fns/locale';
import { useMSALToken } from './msal-utils';

const initialToken = {
  name: "no token received",
  roles: [],
  unique_name: ""
}

const TokenContext = React.createContext<ITokenType>(initialToken);
const TokenSetStateContext = React.createContext<any>(undefined);

const TokenProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, setState] = useState<ITokenType>(initialToken);
  const { accessToken, loading } = useMSALToken();

  useEffect(() => {
    setInterval(() => {
      updateToken();
    }, 1000 * 60 * 15);
    const updateToken = () => {
      if (accessToken) {
        const jwtData = accessToken.split('.')[1];
        const decodedJwtJsonData = window.atob(jwtData);
        const decodedJwtData = JSON.parse(decodedJwtJsonData);
        setState(decodedJwtData);
      }
    };
    updateToken();
  }, [accessToken]);

  return (
    <TokenSetStateContext.Provider value={setState}>
      <TokenContext.Provider value={state}>
        {children}
      </TokenContext.Provider>
    </TokenSetStateContext.Provider>
  );
};

const GetRoles = (): Roles[] => {
  const roles = useContext(TokenContext).roles;
  if (roles === undefined) {
    return [];
  }
  return roles as Roles[];

};

export { TokenContext, TokenProvider, GetRoles };